module.exports = __webpack_public_path__ + "assets/chart2.2.png?e4fd9dc3971aae6f91d4b5321b929769";